import React, { Suspense } from 'react'

// Agentation — dev-only visual feedback toolbar (https://agentation.com).
// Standalone, it copies annotation output to the clipboard with no network
// traffic. Setting VITE_AGENTATION_ENDPOINT (see .env.local.example) enables
// Agent Sync: annotations sync to a local agentation server where coding
// agents pick them up via MCP. Opt-in per developer, because the toolbar
// polls the endpoint every 10 seconds whether or not that server exists.
// Vite statically replaces import.meta.env.PROD, so the lazy import is
// dead-code-eliminated in production builds — neither the package nor a
// lazy chunk ships to users.
const AgentationToolbar = import.meta.env.PROD
    ? null
    : React.lazy(() => import('agentation').then((m) => ({ default: m.Agentation })))

export function DevFeedback(): JSX.Element | null {
    if (!AgentationToolbar || navigator.webdriver) {
        return null
    }
    return (
        <Suspense fallback={null}>
            <AgentationToolbar endpoint={import.meta.env.VITE_AGENTATION_ENDPOINT || undefined} />
        </Suspense>
    )
}
